import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const SelectionContainer = styled.div`
  height: ${Tokens.HeightInput};
  border-radius: ${Tokens.RadiusInput};
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 400;
  color: ${Tokens.ColorTextPrimary};
  background-color: ${Tokens.ColorBackground};
  cursor: pointer;
  width: 130px;
  flex-shrink: 0;
  user-select: none;

  &:hover {
    background-color: ${Tokens.ColorHover};
  }
`

export const DropdownContainer = styled.ul`
  all: unset;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 200;
  list-style: none;
  border: ${Tokens.ColorWhite} solid 0.3rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  min-width: 130px;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 14px;
  font-weight: 400;
  background-color: ${Tokens.ColorBackground};
`

export const DropdownOption = styled.li<{ $active: boolean }>`
  all: unset;
  display: block;
  color: ${({ $active }) => ($active ? Tokens.ColorWhite : Tokens.ColorTextPrimary)};
  background-color: ${({ $active }) => ($active ? Tokens.ColorUIPrimary : 'transparent')};
  text-align: left;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;

  &:hover {
    color: ${Tokens.ColorWhite};
    background-color: ${Tokens.ColorUIPrimary};
  }
`

export const Wrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`
